"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _project = require("@/api/project/project");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      addForm: {
        maxExpertNum: "",
        minViewTime: "",
        scoreRules: 0,
        isBelongSchool: 0,
        id: "",
        stageId: this.$route.query.stageId
      },
      rules: {
        maxExpertNum: [{
          required: true,
          message: "请分配专家数量",
          trigger: "blur"
        }, {
          validator: _validate.isInteger,
          trigger: "blur"
        }],
        minViewTime: [{
          required: true,
          message: "请输入最少浏览时间（分钟）",
          trigger: "blur"
        }, {
          validator: _validate.isInteger,
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    // 获取评分规则
    getRuleList: function getRuleList() {
      var _this = this;
      (0, _project.getScoreRule)({
        stageId: this.$route.query.stageId
      }).then(function (res) {
        if (res.data) {
          _this.addForm = res.data;
        }
      });
    },
    // 提交
    submit: function submit(e) {
      var _this2 = this;
      this.$refs[e].validate(function (valid) {
        if (valid) {
          console.log(_this2.addForm);
          (0, _project.scoreRuleSave)(_this2.addForm).then(function (res) {
            if (res.code === 2000) {
              _this2.$message.success("操作成功。");
              history.go(-1);
            }
          });
        }
      });
    },
    //
    isBack: function isBack() {
      history.back(-1);
    }
  },
  created: function created() {
    this.getRuleList();
  }
};